<template>
  <div class="legend-container row">
    <div class="col-12 title">{{ title }}</div>
    <div v-for="legend of legendData" :key="legend.id" class="col px-0">
      <div class="color" :style="{ 'background-color': legend.color }" />
      <div class="legend-info">
        <span class="legend-name">
          {{ legend.name }}
        </span>
        <span class="legend-description">
          {{ legend.description }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExecutionLevelLegend',
  props: {
    legendData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.legend-container {
  margin: 2rem 0 2.5rem;
  padding: 0 0.5rem;
  .title {
    padding: 0;
    margin-bottom: 0.3rem;
    font-size: 0.875rem;
    color: map-get($colors, 'gray-7');
  }
  .color {
    border: 1px solid #fff;
    height: 0.55rem;
  }
  .legend-info {
    display: flex;
    flex-direction: column;
    padding-right: 3rem;
    .legend-name {
      font-weight: bold;
      color: map-get($colors, 'gray-7');
    }
    .legend-description {
      font-size: 0.75rem;
      color: map-get($colors, 'gray-6');
    }
  }
}
</style>
